import { DEFAULT_PLAYER_CONFIG } from '../data/player.config';
import { IEntityStats } from '../types/entity.types';
import {
  PLAYER_LEVEL_STAT_RATES,
  playerStatAtLevel,
} from '../data/progression.config';
import { collectTrinketPassiveModifiers } from './TrinketService';
import { bakeStatModifiers } from '../utils/buff.utils';
import type { ActiveBuff } from '../types/buff.types';
import { liveLoadoutSource, type LoadoutSource } from './LoadoutSourceService';

export class RunStartProgressionService {
  private static instance: RunStartProgressionService;

  private constructor() {}

  public static getInstance(): RunStartProgressionService {
    if (!RunStartProgressionService.instance) {
      RunStartProgressionService.instance = new RunStartProgressionService();
    }
    return RunStartProgressionService.instance;
  }

  // Permanent stat progression is baked once into the run-start baseStats —
  // frozen for the whole run and serialized as-is, so a mid-run resume needs no
  // re-derivation. Sources: passive per-level scaling (character level) +
  // equipped trinket passives. The talent tree is shelved for this version
  // (cf. docs/talents.md) — its modifiers are no longer pulled in here.
  public buildRunStats(source: LoadoutSource = liveLoadoutSource()): {
    life: number;
    stats: IEntityStats;
  } {
    const stats: IEntityStats = { ...DEFAULT_PLAYER_CONFIG.stats };
    const level = source.level;
    for (const key of Object.keys(
      PLAYER_LEVEL_STAT_RATES,
    ) as (keyof IEntityStats)[]) {
      const rate = PLAYER_LEVEL_STAT_RATES[key];
      if (rate === undefined) {
        continue;
      }
      (stats[key] as number) = playerStatAtLevel(
        DEFAULT_PLAYER_CONFIG.stats[key] as number,
        level,
        rate,
      );
    }
    bakeStatModifiers(stats, [...collectTrinketPassiveModifiers(source)]);
    return { life: stats.maxLife, stats };
  }

  // Behavioral permanents posted as live buffs at run start. The talent tree is
  // shelved (cf. docs/talents.md), so this currently yields nothing; trinket
  // behavioral passives are applied separately via DungeonService.buildPlayerRunEffects.
  public buildPersistentBuffs(): ActiveBuff[] {
    return [];
  }
}

export const runStartProgressionService =
  RunStartProgressionService.getInstance();
